import { type FC } from 'react';

import { Icon } from '../icons/Icon';
import { type IconProps } from '../icons/types';
import { Stack, type StackProps } from '../structural/Stack';

export interface LoadingViewProps extends Omit<
  StackProps,
  | 'alignItems'
  | 'children'
  | 'direction'
  | 'height'
  | 'justifyContent'
  | 'left'
  | 'position'
  | 'top'
  | 'width'
> {
  readonly spinnerColor?: IconProps['color'];
  readonly spinnerSize?: IconProps['size'];
}

export const LoadingView: FC<LoadingViewProps> = ({
  spinnerColor = 'primary.light',
  spinnerSize = '28px',
  ...props
}) => (
  <Stack
    {...props}
    alignItems='center'
    height='100%'
    justifyContent='center'
    left={0}
    position='absolute'
    top={0}
    width='100%'
  >
    <Icon color={spinnerColor} isLoading size={spinnerSize} />
  </Stack>
);
